import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_USERWITHPASSWORDFORGET } from "../../../utils/constants";
import { ForgetPasswordInterface } from "../../../domain/helpers/ForgetPassword";
import userService from "../../../services/userService/userService";

const useUserWithPasswordForget = (page: number, pageSize: number) =>
  useQuery<ForgetPasswordInterface[], Error>({
    queryKey: [
      CACHE_KEY_USERWITHPASSWORDFORGET,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
    ],
    queryFn: () => userService.GetUsersWithPasswordForget(page, pageSize),
    initialData: [],
  });

export default useUserWithPasswordForget;
